import useGetReviewSubjectData from './useGetReviewSubjectData'

export default useGetReviewSubjectData
